import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setupTotp, confirmTotp, disableTotp } from '../api/totp';

export function useTotpSetup() {
  return useMutation({
    mutationFn: setupTotp,
  });
}

export function useTotpConfirm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: confirmTotp,
    onSuccess: () => {
      // Invalidate user query to refresh totp_enabled status
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
}

export function useTotpDisable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disableTotp,
    onSuccess: () => {
      // Invalidate user query to refresh totp_enabled status
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
}
